export const accountConfig = {
  link: 'setting',
  icon: 'setup',
  tip: {
    chinese: '设置',
    english: 'setting',
  },
  uuid: 'SETTING',
  sub: [
    {
      link: 'dictionary',
      tip: {
        chinese: '数据字典',
        english: 'dictionary',
      },
      uuid: 'DATA_DICT',
    },
    {
      link: 'template_setting',
      tip: {
        chinese: '模板配置',
        english: 'template',
      },
      uuid: 'TEMPLATE',
      params: [
        { key: 'page', required: 'true', default: 1, type: 'query' },
        { key: 'pageSize', required: 'true', default: 30, type: 'query' },
        { key: 'templateId', required: 'optional' },
      ],
    },
    {
      link: 'businesses',
      tip: {
        chinese: '应用配置',
        english: 'BusinessConfig',
      },
      uuid: 'BUSINESS',
      params: [
        { key: 'page', required: 'true', default: 1, type: 'query' },
        {
          key: 'pageSize',
          required: 'true',
          default: 10,
          type: 'query',
        },
        { key: 'bizUuid', required: 'optional' },
        { key: 'type', required: 'optional' },
      ],
    },
  ],
};
